var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircleBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 13.6237L12.3125 10.38M9.66875 12.0987L15.125 15.255L20.5812 12.0987M15.125 21.5487V15.2487M20.75 17.7487V12.7487C20.7498 12.5295 20.6919 12.3142 20.5822 12.1244C20.4725 11.9347 20.3148 11.7771 20.125 11.6675L15.75 9.16747C15.56 9.05776 15.3444 9 15.125 9C14.9056 9 14.69 9.05776 14.5 9.16747L10.125 11.6675C9.93516 11.7771 9.77749 11.9347 9.66779 12.1244C9.55809 12.3142 9.50022 12.5295 9.5 12.7487V17.7487C9.50022 17.9679 9.55809 18.1832 9.66779 18.373C9.77749 18.5628 9.93516 18.7204 10.125 18.83L14.5 21.33C14.69 21.4397 14.9056 21.4974 15.125 21.4974C15.3444 21.4974 15.56 21.4397 15.75 21.33L20.125 18.83C20.3148 18.7204 20.4725 18.5628 20.5822 18.373C20.6919 18.1832 20.7498 17.9679 20.75 17.7487Z",
    stroke: "#039855",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleBox);
export default __webpack_public_path__ + "static/media/green_circle_box.2321a7df875d39b279b0cbcbefbb0f55.svg";
export { ForwardRef as ReactComponent };